import {HTH} from "../HTH";
import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HTHSound} from "../sound/HTHSound";
import {HTHHelper} from "../utils/HTHHelper";

export class FSGainedView extends PIXI.Container implements StageLayer {

    public transitionFire: PIXI.spine.Spine;
    private _spinsnSafeWon: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "fsGainedView";
        this.init();
    }

    public showSpinAndSafeWonImage(): gsap.core.Timeline {
        const showTl: gsap.core.Timeline = gsap.timeline(),
            fsLeft: number = HTH.model.freespinsLeft;
        showTl.add(() => {
            this._spinsnSafeWon.visible = true;
            this._spinsnSafeWon.alpha = 1;
        }, 0);
        if (!HTHSound.soundSwitchedDuringFS) {
            if (HTH.model.safeSymbols.length === 2) {
                showTl.add(() => {
                    HTHSound.switchMusic({name: HTHSound.SFS_MUSIC});
                }, 0);
                HTHSound.soundSwitchedDuringFS = true;
            }
        }
        showTl.add(() => {
            HTHSound.playTrack(HTHSound.BG_TRANSITION);
        }, 0);
        showTl.add(HTH.gameViewContainer.addOverlay(0.2, 0.7), 0);
        showTl.add(HTHHelper.playSpineWithTimeline(HTH.fsGainedView.transitionFire, 0, "bw_transition"), 0);
        showTl.add(HTHHelper.playSpineWithTimeline(this._spinsnSafeWon, 0, "win"), 0);
        showTl.to(this._spinsnSafeWon, {alpha: 0, duration: 0.2});
        showTl.add(HTH.gameViewContainer.hideOverlay(0.2), "<");
        showTl.add(() => {
            HTH.keypadPlugin.setZeroBetSpinCounter(fsLeft);
            this._spinsnSafeWon.visible = false;
        });


        return showTl;
    }

    private init() {

        this.transitionFire = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("BigwinTransition"));
        this.transitionFire.position.set(360, 360);
        this.transitionFire.name = "transitionFire";
        this.addChild(this.transitionFire);

        this._spinsnSafeWon = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("+2HellSpins"));
        this._spinsnSafeWon.state.setAnimation(0, "idle", false)
        this._spinsnSafeWon.position.set(360, 360);
        this._spinsnSafeWon.name = "spins won ";
        this._spinsnSafeWon.visible = false;
        this.addChild(this._spinsnSafeWon);

    }


}